import { render, staticRenderFns } from "./UsersPage.vue?vue&type=template&id=77ff07ec&scoped=true"
import script from "./UsersPage.vue?vue&type=script&lang=js"
export * from "./UsersPage.vue?vue&type=script&lang=js"
import style0 from "./UsersPage.vue?vue&type=style&index=0&id=77ff07ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77ff07ec",
  null
  
)

export default component.exports